import Rellax from 'rellax';


/* inviewClass */
(function($) {$.fn.inviewClass = function(options){var settings = $.extend({className: 'is-inview', secondClassName: 'is-inview-done', visibleOffset: 200, secondClassInterval: 1000 }, options); var isDisabled = false; if(settings.SecondClassName === ''){isDisabled = true; } return this.each(function(){var $this = $(this); function inviewClass(){let currentPos = pageYOffset; if(currentPos > $this.offset().top - window.innerHeight + settings.visibleOffset){if(!$this.hasClass(settings.className)){$this.addClass(settings.className); if(!isDisabled){var thisTimeoutID = setTimeout(function(){$this.addClass(settings.secondClassName); clearTimeout(thisTimeoutID); }, settings.secondClassInterval); } } } } inviewClass(); $(window).on('resize', function(){inviewClass(); }); $(window).on('scroll', function(){inviewClass(); }); }) } })(jQuery);

const ht = [];
ht.body = document.querySelector('body');
ht.wrapper = document.querySelector('#barba-wrapper');
ht.container = ht.wrapper.lastElementChild;
ht.breakPoint = 768;
ht.breakPointMobile = 600;
ht.headerNav = document.querySelector('.siteheader__gnav');
ht.headerNavCta = document.querySelector('.siteheader__cta');

ht.anchorTarget = false;

ht.lazyload = function(){

  let currentPos = pageYOffset,
      lazyloadThreshold = 200;

  function doLazyload(){
    currentPos = pageYOffset;

    $('.js-lazyload', ht.container).each(function(){

      let $this = $(this);
      if(currentPos > $this.offset().top - window.innerHeight - lazyloadThreshold){

        if(!$this.hasClass('js-lazyload-done')){

          $this.addClass('js-lazyload-done');
          $this.attr('src', $this.data('src'));

        }

      }
    })

    $('.js-lazyload-bg', ht.container).each(function(){

      let $this = $(this);
      if(currentPos > $this.offset().top - window.innerHeight - lazyloadThreshold){

        if(!$this.hasClass('js-lazyload-done')){

          $this.addClass('js-lazyload-done');
          $this.attr('style', $this.data('style'));

        }

      }
    })

    $('.js-lazyload-heroslider', ht.container).each(function(){
      let $this = $(this);
      if(!$this.hasClass('js-lazyload-done')){
        $this.addClass('js-lazyload-done');
        $this.attr('style', $this.data('style'));
      }
    })

  }
  doLazyload();

  $(window).on('resize scroll', function(){
    doLazyload();
  })

}
ht.lazyload();


ht.anchorTo = (targetID, callback) => {

  let $target = ht.container.querySelector('#' + targetID),
      waitTime = 0,
      thisOffset = 0;

  if(targetID !== 'hero'){
    thisOffset = $('.siteheader__main').height() * -1;
  }

  $.Velocity($target, 'scroll', {
    duration: 800,
    easing: "easeInOutCubic",
    offset: thisOffset,
    delay: waitTime,
    complete: ()=> {
      if(callback){
        callback();
      }
      ht.anchorTarget = false;
    }
  })
}


ht.initAnchorlink = function(){

  //ページ内アンカー（href="#sample"）の形式に対応
  //ページ移動を含むアンカーはbarba側で対応

  const linkArray = document.querySelectorAll('a');


  for(let i = 0; i < linkArray.length; i++){
    let thisLink = linkArray[i];
    linkArray[i].addEventListener('click', (event)=> {

      const thisURL = linkArray[i].getAttribute('href');
      //console.log(thisURL);

      if(thisURL.indexOf('#') === 0){
        event.preventDefault();
        const targetID = thisURL.split('#')[1];
        ht.anchorTo(targetID);
      } else if(ht.container.dataset.page === 'home' && thisURL.indexOf('/#') === 0){
        event.preventDefault();
        const targetID = thisURL.split('#')[1];
        ht.anchorTo(targetID);
      } else if(ht.container.dataset.page === 'home' && thisLink.classList.contains('js-scrolltop')){
        event.preventDefault();
        const targetID = 'hero';
        ht.anchorTo(targetID);
      }
    })
  }

}
ht.initAnchorlink();


ht.initMenu = function(){

  const menuIcon = document.querySelector('.js-menu-icon'),
        menu = document.querySelector('.js-menu-body'),
        menuBody = document.querySelector('.js-menu-body'),
        menuOverlay = document.querySelector('.js-menu-overlay'),
        menuContent = document.querySelector('.js-menu-content');


  const siteHeaderLogo = document.querySelector('.siteheader__logo a');

  ht.openMenu = function(){
    ht.body.classList.add('is-menu-open')
    menuBody.style.display = 'block';
    menuContent.style.opacity = 0;

    $.Velocity(menuOverlay, {
      translateX: [0, window.innerWidth * -1]
    }, {
      duration: 800,
      easing: 'easeOutExpo',
      begin: ()=> {
        setTimeout(()=> {
          $.Velocity(menuContent, {
            opacity: 1
          }, {
            duration: 600,
            easing: 'easeOutQuad',
            complete: function(){

            }
          })
        }, 200);
      }
    })
  }

  ht.closeMenu = function(){
    ht.body.classList.remove('is-menu-open')
    $.Velocity(menuContent, {
      opacity: 0
    }, {
      duration: 200,
      easing: 'easeOutQuad',
      begin: ()=> {
        setTimeout(()=> {
          $.Velocity(menuOverlay, {
            translateX: [window.innerWidth, 0]
          }, {
            duration: 400,
            easing: 'easeOutQuart',
            complete: ()=> {

              menuBody.style.display = 'none';
            }
          })
        }, 100);
      }
    })
  }

  menuIcon.addEventListener('click', ()=> {
    if(!ht.body.classList.contains('is-menu-open')){
      ht.openMenu();
    } else {
      ht.closeMenu();
    }
  })


  siteHeaderLogo.addEventListener('click', ()=> {
    if(ht.body.classList.contains('is-menu-open')){
      ht.closeMenu();
    }
  })

  $('.siteheader__stickybtn a').on('click', ()=>{
    if(ht.body.classList.contains('is-menu-open')){
      ht.closeMenu();
    }
  })

  const menuLinkArray = menuBody.querySelectorAll('a')
  for(let i = 0; i < menuLinkArray.length; i++){
    menuLinkArray[i].addEventListener('click', ()=> {
      ht.closeMenu();
      if(menuLinkArray[i].classList.contains('js-anchor') || menuLinkArray[i].classList.contains('js-pagetop')) {
        ht.closeMenu();
      }
    })
  }
}
ht.initMenu();


ht.initBrandNavModal = function(){

  if(!ht.container.querySelector('.js-brandnavmodal')){
    return;
  }

  const openIcon = ht.container.querySelector('.js-brandnav-open'),
        brandNavBody = ht.container.querySelector('.js-brandnavmodal'),
        brandNavOverlay = brandNavBody.querySelector('.brandnavmodal__overlay'),
        brandNavClose = brandNavBody.querySelector('.brandnavmodal__close'),
        brandNavContent = brandNavBody.querySelector('.brandnavmodal__content')

  ht.openBrandNav = function(){
    ht.body.classList.add('is-brandnav-open-open')
    brandNavBody.style.display = 'block';
    brandNavContent.style.opacity = 0;

    $.Velocity(brandNavOverlay, {
      translateX: [0, window.innerWidth * -1]
    }, {
      duration: 700,
      easing: 'easeOutExpo',
      begin: ()=> {
        setTimeout(()=> {
          $.Velocity(brandNavContent, {
            opacity: 1
          }, {
            duration: 600,
            easing: 'easeOutQuad',
          })
        }, 200);
      }
    })
  }

  ht.closeBrandNav = function(){

    $.Velocity(brandNavContent, {
      opacity: 0
    }, {
      duration: 200,
      easing: 'easeOutQuad',
      begin: ()=> {
        setTimeout(()=> {
          $.Velocity(brandNavOverlay, {
            translateX: [window.innerWidth, 0]
          }, {
            duration: 400,
            easing: 'easeOutQuart',
            complete: ()=> {
              ht.body.classList.remove('is-brandnav-open')
              brandNavBody.style.display = 'none';
            }
          })
        }, 100);
      }
    })
  }


  openIcon.addEventListener('click', ()=> {
    ht.openBrandNav();
  })

  brandNavClose.addEventListener('click', () => {
    ht.closeBrandNav();
  })


  const navLinkArray = document.querySelectorAll('.l-brandtextlist a')
  for(let i = 0; i < navLinkArray.length; i++){
    navLinkArray[i].addEventListener('click', (event)=> {
      //event.preventDefault();
      ht.closeBrandNav();
    })
  }
}
ht.initBrandNavModal();


ht.initGnavCurrent = ()=> {

  const currentPage = ht.container.dataset.page,
        headerNavLinkElemArray = ht.headerNav.querySelectorAll('a'),
        headerNavCtaLinkElemArray = ht.headerNavCta.querySelectorAll('a');

  //console.log(currentPage);

  for(let i = 0; i < headerNavLinkElemArray.length; i++){

    const thisLink = headerNavLinkElemArray[i];
    thisLink.classList.remove('is-current');
    let thisText = thisLink.getAttribute('href');
    thisText = thisText.replace(/\//g, '');

    if(currentPage == thisText.toLowerCase()) {
      thisLink.classList.add('is-current')
    }
  }


  for(let i = 0; i < headerNavCtaLinkElemArray.length; i++){

    const thisLink = headerNavCtaLinkElemArray[i];
    thisLink.classList.remove('is-current');
    let thisText = thisLink.getAttribute('href');
    thisText = thisText.replace(/\//g, '');

    if(currentPage == thisText.toLowerCase()) {
      thisLink.classList.add('is-current')
    }
  }



}
ht.initGnavCurrent();


ht.initProcessNav = () => {

  //pagehead
  if(ht.container.querySelector('.c-prosessnav') == null){
    return;
  }
  let currentPos = window.pageYOffset;

  const processNav = ht.container.querySelector('.c-prosessnav'),
        processBlockArray = ht.container.querySelectorAll('.process-detaillist__item');

  let headerHeight = $('.siteheader__main').height() + 1;

  function scrollFunc(){
    currentPos = window.pageYOffset;

    if(ht.container.querySelector('.c-prosessnav') == null){
      return;
    }

    if(currentPos < $(processBlockArray[1]).offset().top - headerHeight){
      if(!processNav.dataset.current !== '1'){
        processNav.dataset.current = '1';
        //console.log('1')
      }
    } else if(currentPos >= $(processBlockArray[1]).offset().top - headerHeight && currentPos < $(processBlockArray[2]).offset().top - headerHeight) {
      if(!processNav.dataset.current !== '2'){
        processNav.dataset.current = '2';
        //console.log('2')
      }
    } else if(currentPos >= $(processBlockArray[2]).offset().top - headerHeight && currentPos < $(processBlockArray[3]).offset().top - headerHeight) {
      if(!processNav.dataset.current !== '3'){
        processNav.dataset.current = '3';
        //console.log('3')
      }
    } else if(currentPos >= $(processBlockArray[3]).offset().top - headerHeight) {
      if(!processNav.dataset.current !== '4'){
        processNav.dataset.current = '4';
        //console.log('4')
      }
    }


  }
  scrollFunc()

  window.addEventListener('scroll', ()=> {
    scrollFunc()
  })

  window.addEventListener('resize', ()=> {
    headerHeight = $('.siteheader__main').height();
    scrollFunc()
  })

  /*
  function anchorScrollTo(target) {
    if(window.innerWidth > ht.breakPoint){
      localNavFixedOffet = 126;
    } else {
      localNavFixedOffet = 64;
    }
    $.Velocity(target, 'scroll', {
      duration: 600,
      easing: 'easeInOutCubic',
      offset: (localNavFixedOffet + headLocalNavFixed.clientHeight) * -1
    })
  }*/

  //fixed
}
ht.initProcessNav();


ht.initScrollFunc = ()=> {


  const header = document.querySelector('.siteheader');
  const footerContact = document.querySelector('.c-section--contact');

  let scrolledOffset = 100;
  let currentPos = window.pageYOffset;

  function scrollFunc() {
    currentPos = window.pageYOffset;

    if(currentPos > scrolledOffset){
      if(!ht.body.classList.contains('is-scrolled')){
        ht.body.classList.add('is-scrolled');
      }
    } else {
      if(ht.body.classList.contains('is-scrolled')){
        ht.body.classList.remove('is-scrolled')
      }
    }

    if(currentPos > $(footerContact).offset().top - window.innerHeight){
      if(!ht.body.classList.contains('is-footer-visible')){
        ht.body.classList.add('is-footer-visible')
      }
    } else {
      if(ht.body.classList.contains('is-footer-visible')){
        ht.body.classList.remove('is-footer-visible')
      }
    }
  }

  scrollFunc()

   window.addEventListener('scroll', ()=> {
    scrollFunc()
  })

}
ht.initScrollFunc();


ht.initReportSlider = function(){

  if(ht.container.querySelector('.js-reportslider') == null){
    return;
  }

  const reportSliderElem = ht.container.querySelector('.js-reportslider');
  let reportSlider;
  /*
  const reportSlider = new Swiper(reportSliderElem, {
    loop: false,
    spaceBetween: 20,
    slidesPerView: 3,
    speed: 400,
    allowTouchMove: false,
    breakpoints: {
      800: {
        spaceBetween: 37
      },
      600: {
        slidesPerView: 3,
        allowTouchMove: false
      },
      200: {
        slidesPerView: 1,
        allowTouchMove: true
      },
    }
  })*/
  let isReportSliderInitialized = false;

  function initReportSlider(){

    reportSlider = new Swiper(reportSliderElem, {
      loop: false,
      spaceBetween: 20,
      slidesPerView: 'auto',
      speed: 400,
    })
  }

  function toggleSlider(){
    if(window.innerWidth < ht.breakPointMobile){

      initReportSlider()
      isReportSliderInitialized = true;
    } else {

      if(isReportSliderInitialized){
        reportSlider.destroy(true, true);
        isReportSliderInitialized = false;

      } else {
        //console.log('01')
      }

    }
  }
  toggleSlider();

  window.addEventListener('resize', ()=> {
    toggleSlider();
  })


  const sliderContainer = ht.container.querySelector('.c-section--report-article');
        sliderContainer.background = sliderContainer.querySelector('.reportslider-bg')
        sliderContainer.firstSlideMetabox = sliderContainer.querySelector('.swiper-slide .c-card__metabox');

  let bgHeight;

  function setBgHeight(){
    bgHeight = $(sliderContainer).innerHeight() - ($(sliderContainer.firstSlideMetabox).offset().top - $(sliderContainer).offset().top);
    sliderContainer.background.style.height = bgHeight + 'px';
  }
  setBgHeight()

  window.addEventListener('resize', ()=> {
    setBgHeight()
  })
}
window.addEventListener('DOMContentLoaded', ()=> {
  ht.initReportSlider();
})



ht.initSpecialSupporterSlider = function(){

  const supporterSliderElem = ht.container.querySelector('.js-specialsupporterslider');
  let supporterSlider,
  isSupporterSliderInitialized = false;

  if(ht.container.querySelector('.js-specialsupporterslider') == null) {
    return;
  }

  function initSpecialSupporterSlider(){

    supporterSlider = new Swiper(supporterSliderElem, {
      loop: false,
      spaceBetween: 20,
      slidesPerView: 'auto',
      speed: 400,
    })
  }

  function toggleSlider(){
    if(window.innerWidth < ht.breakPointMobile){

      initSpecialSupporterSlider()
      isSupporterSliderInitialized = true;
    } else {

      if(isSupporterSliderInitialized){
        //console.log('00')
        supporterSlider.destroy(true, true);
        isSupporterSliderInitialized = false;

      } else {
        //console.log('01')
      }

    }
  }
  toggleSlider();

  window.addEventListener('resize', ()=> {
    toggleSlider();
  })

}
window.addEventListener('DOMContentLoaded', ()=> {
  ht.initSpecialSupporterSlider();
})



ht.initAboutSlider = function(){

  if(ht.container.querySelector('.js-aboutsupporter-slider') == null){
     return;
  }

  const aboutSupporterSliderArray = ht.container.querySelectorAll('.js-aboutsupporter-slider');

  for(let i = 0; i < aboutSupporterSliderArray.length; i++ ){
    const thisSliderElem = aboutSupporterSliderArray[i],
          thisPrevArrow = thisSliderElem.querySelector('.swiper-button-prev'),
          thisNextArrow = thisSliderElem.querySelector('.swiper-button-next');

    thisPrevArrow.classList.add('swiper-button-prev-' + i);
    thisNextArrow.classList.add('swiper-button-next-' + i);


    if(thisSliderElem.querySelectorAll('.swiper-slide').length < 2 ){
      //console.log('slide 1')
      thisPrevArrow.style.display = 'none';
      thisNextArrow.style.display = 'none';
      return;
    } else {
      //console.log('slide more than 2 ')
    }


    const thisSlider = new Swiper(thisSliderElem, {
      loop: false,
      spaceBetween: 0,
      speed: 400,
      navigation: {
        nextEl: '.swiper-button-next-' + i,
        prevEl: '.swiper-button-prev-' + i,
      },
    });
  }
}
window.addEventListener('DOMContentLoaded', ()=> {
  ht.initAboutSlider();
})


ht.initDonationsReportSlider = function(){

  if(ht.container.querySelector('.js-donationsreport-slider') == null){
     return;
  }


  const donationsReportSliderArray = ht.container.querySelectorAll('.js-donationsreport-slider');

  for(let i = 0; i < donationsReportSliderArray.length; i++ ){
    const thisSliderElem = donationsReportSliderArray[i],
          thisPrevArrow = thisSliderElem.querySelector('.swiper-button-prev'),
          thisNextArrow = thisSliderElem.querySelector('.swiper-button-next');

    thisPrevArrow.classList.add('swiper-button-prev-' + i);
    thisNextArrow.classList.add('swiper-button-next-' + i);
    /*
    if(thisSliderElem.querySelectorAll('.swiper-slide').length < 2 ){
      //console.log('slide 1')
      thisPrevArrow.style.display = 'none';
      thisNextArrow.style.display = 'none';
      return;
    } else {
      //console.log('slide more than 2 ')
    }*/

    if(thisSliderElem.querySelectorAll('.swiper-slide').length > 1 ){
      const thisSlider = new Swiper(thisSliderElem, {
        loop: false,
        spaceBetween: 0,
        speed: 400,
        navigation: {
          nextEl: '.swiper-button-next-' + i,
          prevEl: '.swiper-button-prev-' + i,
        },
      });
    }

  }
}
window.addEventListener('DOMContentLoaded', ()=> {
  ht.initDonationsReportSlider();
})


ht.initHeroSlider = function(){

  if(ht.container.querySelector('.hero__slidecontainer') == null){
    return;
  }

  const heroSliderElem = ht.container.querySelector('.hero__slidecontainer'),
        heroSlidesArray = heroSliderElem.querySelectorAll('.heroslider__slide');

  let animationSpeed = 1500,
      waitTime = 3000;

  let currentSlideIndex = 0,
      nextSlideIndex = 1,
      lastSlideIndex = 2;

  heroSlidesArray[0].classList.add('is-current');
  heroSlidesArray[0].classList.add('is-kenburns');
  heroSlidesArray[1].classList.add('is-next');

  function sliderLoop(){

    //waitTime待つ
    setTimeout(()=> {

      heroSlidesArray[currentSlideIndex].classList.add('is-leave');
      heroSlidesArray[nextSlideIndex].classList.add('is-kenburns');

      //animation終わり、ループの末尾
      setTimeout(()=> {

        for(let i = 0; i < heroSlidesArray.length; i++){
          heroSlidesArray[i].classList.remove('is-leave')
          heroSlidesArray[i].classList.remove('is-next')
          heroSlidesArray[i].classList.remove('is-current')
        }

        heroSlidesArray[nextSlideIndex].classList.add('is-current');
        heroSlidesArray[lastSlideIndex].classList.remove('is-kenburns');

        lastSlideIndex = currentSlideIndex;
        currentSlideIndex++;
        if(currentSlideIndex > heroSlidesArray.length - 1){
          currentSlideIndex = 0;
        }
        nextSlideIndex = currentSlideIndex + 1;
        if(nextSlideIndex > heroSlidesArray.length - 1){
          nextSlideIndex = 0;
        }


        heroSlidesArray[nextSlideIndex].classList.add('is-next');

      }, (animationSpeed - 1));

    }, waitTime);


    setTimeout(sliderLoop, animationSpeed + waitTime);
  }
  sliderLoop();


  heroSliderElem.addEventListener('click', ()=> {
    $(heroSliderElem).toggleClass('is-active');
  })
}
window.addEventListener('DOMContentLoaded', ()=> {

})


ht.initparallax = function(){

  let rellax;
  let isParallaxInitialized = false;

  if(ht.container.querySelector('.rellax') == null) {
    return;
  }

  function toggleParallax(){
    if(window.innerWidth > ht.breakPointMobile){
      if(!isParallaxInitialized){
        isParallaxInitialized = true;
        rellax = new Rellax('.rellax', {
          center:true
        });
      }
    } else {
      if(isParallaxInitialized){
        isParallaxInitialized = false;
        rellax.destroy();
      }
    }
  }
  toggleParallax()

  window.addEventListener('resize', ()=> {
    toggleParallax();
  })
}
ht.initparallax();


ht.initInviewClass = function() {

  $('.js-inview').inviewClass({
    visibleOffset: 200,
    secondClassInterval: 1000
  });



  /*
  $('.js-inview-section').inviewClass({
    visibleOffset: 200,
    secondClassInterval: 1000
  });
  */

  let currentPos = pageYOffset;
  //let visibleOffset

  function scrollFunc(){
    currentPos = pageYOffset;
    $('.js-inview-section').each(function(){
      let $this = $(this);
      if(currentPos > $this.offset().top - window.innerHeight + 200){
        if(!$this.hasClass('is-inview')) {
          $this.addClass('is-inview');

          setTimeout(function(){
            $('.js-message-inview').inviewClass({
              visibleOffset: 200,
              secondClassInterval: 1000
            });
          }, 1000);

        }
      }
    });
  }
  scrollFunc()

  $(window).on('scroll', function(){
    scrollFunc()
  })







}
window.addEventListener('DOMContentLoaded', ()=> {
  ht.initInviewClass();
})

ht.setLoadingSize = function(){

  const loadingElem = document.querySelector('.loading');

  let windowWidth = window.innerWidth,
  windowHeight;

  loadingElem.style.height = window.innerHeight + 'px';
  loadingElem.classList.add('is-sizeset');

  window.addEventListener('resize', function(){
    windowHeight = window.innerHeight;

    if(window.innerWidth <= ht.breakPoint){
      if(window.innerWidth !== windowWidth) {
        loadingElem.style.height = window.innerHeight + 'px';
        windowWidth = window.innerWidth;
      }
    } else {
      loadingElem.style.height = window.innerHeight + 'px';
      windowWidth = window.innerWidth;
    }
  })
}
ht.setLoadingSize();


ht.isLoaded = false;
ht.initLoading = function(){

  //ht.initImageBoardSlider();
  //ht.initMemberSlider();

  function loadingSequence(){

    ht.isLoaded = true;

    let animationCompleteIndex = 0;

    const loadingCover = document.querySelector('.loading__cover--02');


    ht.body.classList.add('is-loaded');

    loadingCover.addEventListener('animationend', ()=>{
      //console.log('loading-half')
      ht.body.classList.add('is-loading-half');
      animationCompleteIndex++;

      if(animationCompleteIndex == 1){
        ht.body.classList.add('is-loadinginner-hide');
        if(ht.container.dataset.page === 'home'){
          ht.initHeroSlider();
          $('.heroslider__slide--02, .heroslider__slide--03, .heroslider__slide--04').show();
        }
      } else if(animationCompleteIndex == 2) {
        ht.body.classList.add('is-loading-hide')

      }

    });

    if($('.ua-ie').length > 0){
      $('.loading').fadeOut(400, function(){
        if(ht.container.dataset.page === 'home'){
          ht.initHeroSlider();
          $('.heroslider__slide--02, .heroslider__slide--03, .heroslider__slide--04').show();
        }
      })
    }
  }

  //const hasSessionData = sessionStorage.getItem('has-sessiondata')
  if(ht.hasSessionData === 'yes'){
    if(ht.container.dataset.page === 'home'){
      ht.initHeroSlider();
      $('.heroslider__slide--02, .heroslider__slide--03, .heroslider__slide--04').show();
    }
  }else{
    //console.log('first time')
    sessionStorage.setItem('has-sessiondata', 'yes')
    loadingSequence();
  }

}
ht.hasSessionData = sessionStorage.getItem('has-sessiondata')
if(ht.hasSessionData === 'yes'){
  //console.log('defer not first time')
  $('.loading').hide();
  $('.heroslider').hide();
  $('.heroslider__slide--02, .heroslider__slide--03, .heroslider__slide--04').hide();
  $('.heroslider').fadeIn();
  //console.log('fadeIn');
}


$(window).on('load', function(){
  if(!ht.isLoaded){
    ht.initLoading();
  }
});

setTimeout(function(){
  if(!ht.isLoaded){
    ht.initLoading();
  }
}, 2000);


//ht.istoggleHeaderInitialized = false;

ht.toggleHeader = function(){

  if(ht.container.querySelector('.hero') == null){
    ht.body.classList.remove('is-hero-visible')
    return;
  }

  const heroSection = ht.container.querySelector('.hero');

  let currentPos = window.pageYOffset;
  function scrollFunc(){
    currentPos = window.pageYOffset;

    if(ht.container.querySelector('.hero') == null){
      ht.body.classList.remove('is-hero-visible')
      return;
    }

    if(currentPos < $(heroSection).offset().top + $(heroSection).height()){
      if(!ht.body.classList.contains('is-hero-visible')) {
        ht.body.classList.add('is-hero-visible')
      }
    } else {
      if(ht.body.classList.contains('is-hero-visible')) {
        ht.body.classList.remove('is-hero-visible')
      }
    }
  }
  scrollFunc()

  window.addEventListener('scroll', ()=> {
    scrollFunc()
  })

}
ht.toggleHeader();


ht.setHeroSize = function(){

  if(ht.container.querySelector('#hero') == null){
    return;
  }

  const heroElem = document.querySelector('#hero'),
        loadingElem = document.querySelector('.loading');

  let windowWidth = window.innerWidth,
  windowHeight;

  heroElem.style.height = window.innerHeight + 'px';
  loadingElem.style.height = window.innerHeight + 'px';

  window.addEventListener('resize', function(){
    windowHeight = window.innerHeight;

    if(window.innerWidth <= ht.breakPoint){
      if(window.innerWidth !== windowWidth) {
        heroElem.style.height = window.innerHeight + 'px';
        loadingElem.style.height = window.innerHeight + 'px';
        windowWidth = window.innerWidth;
      }
    } else {
      loadingElem.style.height = window.innerHeight + 'px';
      heroElem.style.height = window.innerHeight + 'px';
      windowWidth = window.innerWidth;
    }
  })
}
ht.setHeroSize();


ht.initCountUp = function(){

  if(ht.container.querySelector('.c-countup') == null){
    return;
  }

  const countUpElemArray = ht.container.querySelectorAll('.c-countup');
  let currentPos = pageYOffset;
  let showOffset = 100;

  for(let i = 0; i < countUpElemArray.length; i++){

    let isShowed = false;

    const thisElem = countUpElemArray[i];
    const thisNumberElem = thisElem.querySelector('.c-countup__number');

    const thisInnerHTML = thisNumberElem.innerHTML;
    const thisTargetNumber = thisInnerHTML.replace(/,/g, '');
    thisNumberElem.innerHTML = '';
    thisElem.style.opacity = '0';

    function scrollFunc(){
      currentPos = pageYOffset;

      if(currentPos > $(thisElem).offset().top - window.innerHeight + showOffset){

        if(!isShowed){
          isShowed = true;
          thisElem.style.opacity = '1';
          $.Velocity(thisNumberElem, {
            tween: thisTargetNumber // Optional
          },{
            duration: 2000,
            easing: 'easeOutExpo',
            progress: function(elements, complete, remaining, start, tweenValue) {
              thisNumberElem.innerHTML = parseInt(tweenValue).toLocaleString();
            }
          })
        }

      }
    }
    scrollFunc()

    $(window).on('scroll', ()=> {
      scrollFunc();
    })
  }
}
ht.initCountUp()


ht.initBarba = function() {

  Barba.Pjax.start();

  var FadeTransition = Barba.BaseTransition.extend({
    start: function() {

      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {

      let fadeTime = 300;
      return $.Velocity(this.oldContainer, {
        opacity: 0,
      },{
        duration: fadeTime,
        easing: 'easeOutQuad'
      })
      $.promise();
    },

    fadeIn: function() {

      var _this = this;
      var thisNewContainer = this.newContainer;

      this.oldContainer.style.display = 'none';

      $(window).scrollTop(0);
      ht.lazyload();
      ht.initparallax();
      ht.toggleHeader();
      ht.initCountUp();


      let fadeTime = 600;

      thisNewContainer.style.visibility = 'visible';
      thisNewContainer.style.opacity = '0';
      $.Velocity(thisNewContainer, {
        opacity: 1
      },{
        duration: fadeTime,
        easing: 'easeInOutQuad',
        complete: function(){
          _this.done();
        }
      })
    }
  });

  if($('.ua-ie, .ua-edge').length < 1){
    Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
    Barba.Pjax.preventCheck = function(evt, element) {

      if(element){

      //WordPressの管理バーのリンクはPjaxを無効に
      if(element.classList.contains('ab-item')){
        return false;
      }
      //編集ボタンのリンクはPjaxを無効に
      if(element.classList.contains('editlink')){
        return false;
      }

      // アンカーリンクであり同一ページでなければPjaxを有効に
      let url = location.protocol + '//' + location.host + location.pathname;
      let extract_hash = element.href.replace(/#.*$/,"");
      if (element.href.startsWith(location.protocol + '//' + location.host)) {
        if (element.href.indexOf('#') > -1 &&  extract_hash != url ){
          ht.anchorTarget = element.href.split('#')[1];
          return true;
        } else {
          const anchorTarget = element.href.split('#')[1];
          if(anchorTarget){
            ht.anchorTo(anchorTarget);
          }

        }
      }

      if (!Barba.Pjax.originalPreventCheck(evt, element)) {
        return false;
      }
    }
    return true;

  };
}

  Barba.Pjax.getTransition = function() {
    return FadeTransition;
  };

  Barba.Dispatcher.on('newPageReady', function() {

    ht.container = ht.wrapper.lastElementChild;

    if(ht.container.dataset.page === 'home'){
      ht.body.classList.add('home')
    } else {
      ht.body.classList.remove('home')
    }


    ht.initInviewClass();

    ht.initReportSlider();
    ht.initSpecialSupporterSlider();
    ht.initAboutSlider();
    ht.initDonationsReportSlider();
    ht.setHeroSize();
    ht.initHeroSlider();
    ht.initProcessNav();
    ht.initGnavCurrent();

  });

  Barba.Dispatcher.on('transitionCompleted', function() {
    if(ht.anchorTarget){
      ht.anchorTo(ht.anchorTarget);
    }
  });
}
ht.initBarba();

